import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Input, Select, Switch, message, Spin, Tooltip } from 'antd'
import { JsonEditor as Editor } from "jsoneditor-react"
import 'jsoneditor-react/es/editor.min.css'
import { getProductionStageDetail, createProductionStage, updateProductionStage } from '../../../services/api/ProductionStageService'
import { getListPartner } from '../../../services/api/3dApi'
import getHistory from '../../../getHistory'

const allowedModes = [Editor.modes.text, Editor.modes.code, Editor.modes.tree, Editor.modes.form, Editor.modes.view]

function ProductionStageCreatePage(props) {
    const { stageId } = { ...props }
    const [loading, setLoading] = useState(false)
    const [name, setName] = useState('')
    const [partner, setPartner] = useState('')
    const [flow, setFlow] = useState('')
    const [nameBIS, setNameBIS] = useState('')
    const [keyBIS, setKeyBIS] = useState('')
    const [timestampBIS, setTimestampBIS] = useState('')
    const [nameBS, setNameBS] = useState('')
    const [keyBS, setKeyBS] = useState('')
    const [timestampBS, setTimestampBS] = useState('')
    const [updateBStatus, setUpdateBStatus] = useState(false)
    const [updateBIStatus, setUpdateBIStatus] = useState(false)
    const [allStatus, setAllStatus] = useState(false)
    const [additional, setAdditional] = useState([])
    const [listPartner, setListPartner] = useState([])
    const [errValidate, setErrValidate] = useState({})
    const [updateOrderStatus, setUpdateOrderStatus] = useState(false)
    const [updateManyBatches, setUpdateManyBatches] = useState(false)
    const [service, setService] = useState('')
    const [key, setKey] = useState('')
    const [nameOPS, setNameOPS] = useState('')
    const [keyOPS, setKeyOPS] = useState('')
    const [timestampOPS, setTimestampOPS] = useState('')

    const getPartner = async () => {
        const payload = {
            page: 1,
            limit: 10000,
            hidden: false,
        }
        try {
            const { data, success } = await getListPartner(payload)
            const { partners } = data
            if (!success) return
            setListPartner(partners)
        } catch (e) {
            console.log(e.message)
        }
    }

    const getDetail = async (id) => {
        setLoading(true)
        try {
            const { data: Data } = await getProductionStageDetail(id)
            const { message: mess, success, data } = Data
            const { update_flow = {}, partner, batch_state: BS = {}, batch_item_state: BIS = {}, service, order_production_state: OPS = {} } = data || {}
            const { id: partnerId } = { ...partner }
            if (!success) {
                throw new Error(mess)
            }
            setAdditional(data.additional)
            setName(data.name)
            setFlow(update_flow.flow)
            setPartner(partnerId || '')
            setUpdateBIStatus(update_flow.update_batch_item_status)
            setUpdateBStatus(update_flow.update_batch_status)
            setAllStatus(update_flow.all_in_one_status)
            setNameBS(BS.name)
            setKeyBS(BS.key)
            setTimestampBS(BS.timestamp_key)
            setNameBIS(BIS.name)
            setKeyBIS(BIS.key)
            setTimestampBIS(BIS.timestamp_key)
            setUpdateOrderStatus(update_flow.update_order_status)
            setUpdateManyBatches(update_flow.update_many_batches)
            setService(service)
            setKey(data.key)
            setNameOPS(OPS.name || "")
            setKeyOPS(OPS.key || "")
            setTimestampOPS(OPS.timestamp_key || "")
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }

    }

    useEffect(() => {
        getPartner()
        if (stageId) {
            getDetail(stageId)
        }
    }, [stageId])

    const handleChangeInput = (field, value) => {
        delete errValidate[field]
        if (field === 'name') setName(value)
        if (field === 'partner') setPartner(value)
        if (field === 'nameBIS') setNameBIS(value)
        if (field === 'nameBS') setNameBS(value)
        if (field === 'keyBIS') setKeyBIS(value)
        if (field === 'keyBS') setKeyBS(value)
        if (field === 'timestampKeyBIS') setTimestampBIS(value)
        if (field === 'timestampKeyBS') setTimestampBS(value)
        if (field === 'key') setKey(value)
        if (field === 'nameOPS') setNameOPS(value)
        if (field === 'keyOPS') setKeyOPS(value)
        if (field === 'timestampKeyOPS') setTimestampOPS(value)
    }
    const handleChangeSelect = (field, value) => {
        delete errValidate[field]
        if (field === 'flow') setFlow(value)
        if (field === 'partner') setPartner(value)
        if (field === 'service') setService(value)
    }

    const handleSwitch = (field, value) => {
        if (field === 'updateBStatus') setUpdateBStatus(value)
        if (field === 'updateBIStatus') setUpdateBIStatus(value)
        if (field === 'allStatus') setAllStatus(value)
        if (field === 'updateOrderStatus') setUpdateOrderStatus(value)
        if (field === 'updateManyBatches') setUpdateManyBatches(value)
    }

    const handleChangeJson = (value) => {
        setAdditional(value)
    }

    const validate = () => {
        setErrValidate({})
        setName(name.trim())
        setNameBIS(nameBIS.trim())
        setNameBS(nameBS.trim())
        setKeyBIS(keyBIS.trim())
        setKeyBS(keyBS.trim())
        setTimestampBIS(timestampBIS.trim())
        setTimestampBS(timestampBS.trim())
        setKey(key.trim())
        setNameOPS(nameOPS.trim())
        setKeyOPS(keyOPS.trim())
        setTimestampOPS(timestampOPS.trim())

        const regex = /^[a-zA-Z0-9_]+$/
        let err = {}

        if (!name || !name.trim()) {
            err.name = 'Nhập tên công đoạn.'
            !name.trim() && setName('')
        }
        if (!partner) err.partner = 'Chọn đối tác sản xuất.'
        if (!flow) err.flow = 'Chọn flow.'
        if (!key || !key.trim()) {
            err.key = 'Nhập key.'
            !key.trim() && setKey('')
        }
        if (key.trim()) {
            if (!regex.test(key.trim())) {
                err.key = 'Key chỉ nên chứa số, ký tự và dấu gạch chân.'
            }
        }

        if (!service) err.service = 'Chọn service.'
        if (!nameBIS || !nameBIS.trim()) {
            err.nameBIS = 'Nhập Batch item state name.'
            !nameBIS.trim() && setNameBIS('')
        }
        if (!keyBIS || !keyBIS.trim()) {
            err.keyBIS = 'Nhập Batch item state key.'
            !keyBIS.trim() && setKeyBIS('')
        }
        if (!nameBS || !nameBS.trim()) {
            err.nameBS = 'Nhập Batch state name.'
            !nameBS.trim() && setNameBS('')
        }
        if (!keyBS || !keyBS.trim()) {
            err.keyBS = 'Nhập Batch state key.'
            !keyBS.trim() && setKeyBS('')
        }

        if (keyBIS.trim()) {
            if (!regex.test(keyBIS.trim())) {
                err.keyBIS = 'Key chỉ nên chứa số, ký tự và dấu gạch chân.'
            }
        }
        if (keyBS.trim()) {
            if (!regex.test(keyBS.trim())) {
                err.keyBS = 'Key chỉ nên chứa số, ký tự và dấu gạch chân.'
            }
        }

        if (updateOrderStatus && (!nameOPS || !nameOPS.trim())) {
            err.nameOPS = 'Nhập order production state name.'
            !nameOPS.trim() && setNameOPS('')
        }

        if (updateOrderStatus && (!keyOPS || !keyOPS.trim())) {
            err.keyOPS = 'Nhập order production state key.'
            !keyOPS.trim() && setKeyOPS('')
        }

        if (keyOPS.trim()) {
            if (!regex.test(keyOPS.trim())) {
                err.keyOPS = 'Key chỉ nên chứa số, ký tự và dấu gạch chân.'
            }
        }

        if (Object.keys(err).length > 0) {
            setErrValidate(err)
            return false
        } else {
            return true
        }
    }

    const onCreate = async (payload) => {
        setLoading(true)
        try {
            const { data: res } = await createProductionStage(payload)
            const { success, message: mess } = { ...res }
            if (!success) {
                throw new Error(mess)
            }
            const history = getHistory()
            history.push(`/production-stage`)
            message.success('Create Success!')
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const onUpdate = async (payload) => {
        setLoading(true)
        try {
            const { data: res } = await updateProductionStage(stageId, payload)
            const { success, message: mess } = { ...res }
            if (!success) {
                throw new Error(mess)
            }
            const history = getHistory()
            history.push(`/production-stage`)
            message.success('Update Success!')
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const handleSave = async () => {
        if (!validate()) return
        const payload = {
            name: name.trim(),
            key: key.trim(),
            partner: {
                id: listPartner.length ? listPartner.find(i => i._id === partner)._id : '',
                name: listPartner.length ? listPartner.find(i => i._id === partner).name : '',
            },
            update_flow: {
                flow: flow,
                update_batch_status: updateBStatus,
                update_batch_item_status: updateBIStatus,
                all_in_one_status: allStatus,
                update_order_status: updateOrderStatus,
                update_many_batches: updateManyBatches
            },
            batch_item_state: {
                name: nameBIS.trim(),
                key: keyBIS.trim(),
                timestamp_key: timestampBIS.trim(),
            },
            batch_state: {
                name: nameBS.trim(),
                key: keyBS.trim(),
                timestamp_key: timestampBS.trim(),
            },
            additional: additional,
            order_production_state: {
                name: nameOPS.trim(),
                key: keyOPS.trim(),
                timestamp_key: timestampOPS.trim(),
            },
            service
        }

        if (stageId && stageId !== 'create') {
            onUpdate(payload)
        } else {
            onCreate(payload)
        }
    }

    const flowOptions = [
        { label: 'Batch to item', value: 'batch_to_item', },
        { label: 'One item to batch', value: 'one_item_to_batch', },
        { label: 'All items to batch', value: 'all_items_to_batch', },
    ]

    const serviceOptions = [
        { label: '3D', value: '3d', },
        { label: '3D Partner', value: '3d-partner', },
    ]

    const partnerOptions = listPartner.filter(i => i.name === "QUANG MINH" || i.name === "TOÀN CẦU" || i.name === "BINH MINH").map(i => ({
        label: i.name,
        value: i._id,
    }))

    const tooltipTitle = {
        batch_to_item: 'Cập nhật trạng thái lô ảnh hưởng đến item trong lô',
        item_to_batch: 'Cập nhật trạng thái tất cả item trong lô ảnh hưởng đến trạng thái lô'
    }

    return (
        <div className='ProductionStageCreatePage'>
            <div className="ReturnPage mb-2">
                <Link to={'/production-stage'} className="txt-16">
                    <i className="fa fa-chevron-left mr-1" /> Quản lý công đoạn sản xuất
                </Link>
            </div>
            <div className='PageHeading d-flex align-items-center justify-content-between border-bottom'>
                <h1 className="PageTitle font-weight-bold mb-0">Chi tiết công đoạn sản xuất</h1>
                <div className="RightTop">
                    <div className='Actions mb-2'>
                        <Link to={'/production-stage'}>
                            <button
                                className='btn btn-secondary mx-1'
                                style={{ background: '#C4C4C4' }}
                            >
                                Huỷ
                            </button>
                        </Link>
                        <button
                            className='btn btn-primary mx-1'
                            style={{ background: '#4A80F7' }}
                            onClick={handleSave}
                        >
                            Lưu
                        </button>
                    </div>
                </div>
            </div>
            <div className="SectionInner mt-3 card px-3 py-3">
                <Spin spinning={loading} tip='Loading...'>
                    <div className="FormProductionStage" style={{ width: '50%' }}>
                        <div className="item-group-3">
                            <div className="item mb-3">
                                <h6 className='font-weight-bold mb-1'>Tên công đoạn <span className='text-danger'>*</span></h6>
                                <Input
                                    value={name || ''}
                                    allowClear
                                    placeholder='Tên công đoạn'
                                    onChange={(e) => handleChangeInput('name', e.target.value)}
                                />
                                {errValidate['name'] &&
                                    <div className='text-danger mt-1'>{errValidate['name']}</div>
                                }
                            </div>
                            <div className="item mb-3">
                                <h6 className='font-weight-bold mb-1'>Đối tác sản xuất <span className='text-danger'>*</span></h6>
                                <Select
                                    value={partner || []}
                                    style={{ width: '100%' }}
                                    allowClear
                                    placeholder='Đối tác sản xuất'
                                    onChange={(value) => handleChangeInput('partner', value)}
                                    options={partnerOptions}
                                />
                                {errValidate['partner'] &&
                                    <div className='text-danger mt-1'>{errValidate['partner']}</div>
                                }
                            </div>
                            <div className="item mb-3">
                                <h6 className='font-weight-bold mb-1 cursor-pointer'>
                                    <Tooltip title={tooltipTitle[flow] || ""} placement='topLeft'>
                                        Update flow <span className='text-danger'>*</span>
                                    </Tooltip>
                                </h6>
                                <Select
                                    value={flow || []}
                                    style={{ width: '100%' }}
                                    allowClear
                                    placeholder='Flow'
                                    options={flowOptions}
                                    onChange={(value) => handleChangeSelect('flow', value)}
                                />
                                {errValidate['flow'] &&
                                    <div className='text-danger mt-1'>{errValidate['flow']}</div>
                                }
                            </div>
                        </div>
                        <div className="item mb-3">
                            <div className='container px-0'>
                                <div className="item-group-3">
                                    <div className='item'>
                                        <Tooltip title="Cập nhật trạng thái lô">
                                            <label className='font-weight-bold mr-2'>Update batch status</label>
                                            <Switch
                                                checked={updateBStatus}
                                                onChange={(value) => handleSwitch('updateBStatus', value)}
                                            />
                                        </Tooltip>
                                    </div>
                                    <div className='item'>
                                        <Tooltip title="Cập nhật trạng thái item trong lô">
                                            <label className='font-weight-bold mr-2'>Update batch item status</label>
                                            <Switch
                                                checked={updateBIStatus}
                                                onChange={(value) => handleSwitch('updateBIStatus', value)}
                                            />
                                        </Tooltip>
                                    </div>
                                    <div className='item'>
                                        <Tooltip title="Cập nhật trạng thái sản xuất của đơn">
                                            <label className='font-weight-bold mr-2'>Update order status</label>
                                            <Switch
                                                checked={updateOrderStatus}
                                                onChange={(value) => handleSwitch('updateOrderStatus', value)}
                                            />
                                        </Tooltip>
                                    </div>
                                </div>

                                <div className='item-group-3 mt-3'>
                                    <div className='item'>
                                        <Tooltip title="Cập nhật trạng thái nhiều lô cùng lúc">
                                            <label className='font-weight-bold mr-2'>Update many batches</label>
                                            <Switch
                                                checked={updateManyBatches}
                                                onChange={(value) => handleSwitch('updateManyBatches', value)}
                                            />
                                        </Tooltip>
                                    </div>
                                    <div className='item'>
                                        <Tooltip title="Tất cả item trong lô phải cùng trạng thái của công đoạn trước đó hoặc 'moved'">
                                            <label className='font-weight-bold mr-2'>All in one status</label>
                                            <Switch
                                                checked={allStatus}
                                                onChange={(value) => handleSwitch('allStatus', value)}
                                            />
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="item-group-2">
                            <div className="item mb-3">
                                <h6 className='font-weight-bold mb-1'>Key <span className='text-danger'>*</span></h6>
                                <Input
                                    value={key || ''}
                                    allowClear
                                    placeholder='Nhập key'
                                    onChange={(e) => handleChangeInput('key', e.target.value)}
                                />
                                {errValidate['key'] &&
                                    <div className='text-danger mt-1'>{errValidate['key']}</div>
                                }
                            </div>
                            <div className="item mb-3">
                                <h6 className='font-weight-bold mb-1'>Service <span className='text-danger'>*</span></h6>
                                <Select
                                    value={service || []}
                                    style={{ width: '100%' }}
                                    allowClear
                                    placeholder='service'
                                    options={serviceOptions}
                                    onChange={(value) => handleChangeSelect('service', value)}
                                />
                                {errValidate['service'] &&
                                    <div className='text-danger mt-1'>{errValidate['service']}</div>
                                }
                            </div>
                        </div>
                        <div className="item mb-3">
                            <Tooltip title="Trạng thái lô" placement='topLeft'>
                                <h6 className='font-weight-bold mb-1 cursor-pointer'>Batch state</h6>
                            </Tooltip>
                            <div className='item-group-3 mt-2'>
                                <div className="item">
                                    <label className='font-weight-bold mr-2'>Name <span className='text-danger'>*</span></label>
                                    <Input
                                        value={nameBS || ''}
                                        allowClear
                                        placeholder='Name'
                                        onChange={(e) => handleChangeInput('nameBS', e.target.value)}
                                    />
                                    {errValidate['nameBS'] &&
                                        <div className='text-danger mt-1'>{errValidate['nameBS']}</div>
                                    }
                                </div>
                                <div className="item">
                                    <label className='font-weight-bold mr-2'>Key <span className='text-danger'>*</span></label>
                                    <Input
                                        value={keyBS || ''}
                                        placeholder='Key'
                                        allowClear
                                        onChange={(e) => handleChangeInput('keyBS', e.target.value)}
                                    />
                                    {errValidate['keyBS'] &&
                                        <div className='text-danger mt-1'>{errValidate['keyBS']}</div>
                                    }
                                </div>
                                <div className="item">
                                    <label className='font-weight-bold mr-2'>Timestamp key</label>
                                    <Input
                                        value={timestampBS || ''}
                                        placeholder='Timestamp key'
                                        allowClear
                                        onChange={(e) => handleChangeInput('timestampKeyBS', e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="item mb-3">
                            <Tooltip title="Trạng thái item trong lô" placement='topLeft'>
                                <h6 className='font-weight-bold mb-1 cursor-pointer'>Batch item state</h6>
                            </Tooltip>
                            <div className='item-group-3 mt-2'>
                                <div className="item">
                                    <label className='font-weight-bold mr-2'>Name <span className='text-danger'>*</span></label>
                                    <Input
                                        value={nameBIS || ''}
                                        allowClear
                                        placeholder='Name'
                                        onChange={(e) => handleChangeInput('nameBIS', e.target.value)}
                                    />
                                    {errValidate['nameBIS'] &&
                                        <div className='text-danger mt-1'>{errValidate['nameBIS']}</div>
                                    }
                                </div>
                                <div className="item">
                                    <label className='font-weight-bold mr-2'>Key <span className='text-danger'>*</span></label>
                                    <Input
                                        value={keyBIS || ''}
                                        placeholder='Key'
                                        allowClear
                                        onChange={(e) => handleChangeInput('keyBIS', e.target.value)}
                                    />
                                    {errValidate['keyBIS'] &&
                                        <div className='text-danger mt-1'>{errValidate['keyBIS']}</div>
                                    }
                                </div>
                                <div className="item">
                                    <label className='font-weight-bold mr-2'>Timestamp key</label>
                                    <Input
                                        value={timestampBIS || ''}
                                        placeholder='Timestamp key'
                                        allowClear
                                        onChange={(e) => handleChangeInput('timestampKeyBIS', e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="item mb-3">
                            <Tooltip title="Trạng thái sản xuất của đơn" placement='topLeft'>
                                <h6 className='font-weight-bold mb-1 cursor-pointer'>Order Production State</h6>
                            </Tooltip>
                            <div className='item-group-3 mt-2'>
                                <div className="item">
                                    {
                                        updateOrderStatus ? <label className='font-weight-bold mr-2'>Name <span className='text-danger'>*</span></label> : <label className='font-weight-bold mr-2'>Name</label>
                                    }

                                    <Input
                                        value={nameOPS || ''}
                                        allowClear
                                        placeholder='Name'
                                        onChange={(e) => handleChangeInput('nameOPS', e.target.value)}
                                    />
                                    {errValidate['nameOPS'] &&
                                        <div className='text-danger mt-1'>{errValidate['nameOPS']}</div>
                                    }
                                </div>
                                <div className="item">
                                    {
                                        updateOrderStatus ? <label className='font-weight-bold mr-2'>Key <span className='text-danger'>*</span></label> : <label className='font-weight-bold mr-2'>Key</label>
                                    }

                                    <Input
                                        value={keyOPS || ''}
                                        placeholder='Key'
                                        allowClear
                                        onChange={(e) => handleChangeInput('keyOPS', e.target.value)}
                                    />
                                    {errValidate['keyOPS'] &&
                                        <div className='text-danger mt-1'>{errValidate['keyOPS']}</div>
                                    }
                                </div>
                                <div className="item">
                                    <label className='font-weight-bold mr-2'>Timestamp key</label>
                                    <Input
                                        value={timestampOPS || ''}
                                        placeholder='Timestamp key'
                                        allowClear
                                        onChange={(e) => handleChangeInput('timestampKeyOPS', e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* <div className="item mb-3 d-flex">
                        <h6 className='font-weight-bold mb-1 mr-5'>Trạng thái</h6>
                        <Switch />
                    </div> */}
                    </div>
                    <div className="ProductionStageDetails">
                        <Tooltip title="Cấu hình khác" placement='topLeft'>
                            <h6 className='font-weight-bold mb-1 mr-5 cursor-pointer'>Additional</h6>
                        </Tooltip>
                        {stageId ?
                            (!!name || !!flow) &&
                            <Editor
                                value={additional || []}
                                onChange={handleChangeJson}
                                allowedModes={allowedModes}
                            /> :
                            <Editor
                                value={additional || []}
                                onChange={handleChangeJson}
                                allowedModes={allowedModes}
                            />
                        }
                    </div>
                </Spin>
            </div>
        </div>

    )
}

export default ProductionStageCreatePage